import Header from "../blocks/header";
import Dashboard from "../blocks/dashboard";
import Toolbar from "@mui/material/Toolbar";
import * as React from "react";
import Copyright from "../blocks/copyright";
import Box from "@mui/material/Box";
import {useNavigate, useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import TextField from "@mui/material/TextField";
import {useEffect, useState} from "react";
import {connect} from "react-redux";
import {editSaveDocument, getDocument, messageReset} from "../store/documents";
import {getAllVerifyResponse} from "../store/logIn";
import Button from "@mui/material/Button";
import {toast} from "react-toastify";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import {FormControl, InputLabel, MenuItem, Select} from "@mui/material";

function EditDocument(props) {
    const navigate = useNavigate()
    const params = useParams()
    const {t, i18n} = useTranslation()
    const toBack = () => {
        navigate(-1);
    }
    const [document_title, setDocumentTitle] = useState('')
    const [document_file, setDocumentFile] = useState('')
    // 7-o'zgarish: Kategoriya
    const [category, setCategory] = useState('other')

    useEffect(() => {
        props.getDocument(params.id)
    }, [])

    useEffect(() => {
        setDocumentTitle(props.document_single.title)
        // 7-o'zgarish: Mavjud kategoriyani yuklash
        if (props.document_single.category) {
            setCategory(props.document_single.category)
        }
    }, [props.document_single])

    function saveFormData(e) {
        e.preventDefault()
        const files = e.target[4].files
        if (!files[0]) {
            setDocumentFile('*')
        } else {
            const data = {
                "id": params.id,
                "title": document_title,
                "category": category,
                "file": files[0],
            }
            props.editSaveDocument(data)
        }
    }

    function prepareUpload(event) {
        var files = event.target.files;
        setDocumentFile(files[0].name)
    }

    useEffect(() => {
        if (props.message === true) {
            setDocumentFile('')
            setDocumentTitle('')
            navigate('/documents/')
        } else if (props.message === 'error') {
            toast.error(t('save_error'), {theme: 'colored'})
            props.messageReset()
        }
    }, [props.message])

    return <div>
        <div className={'page'}>
            <Header/>
            <Dashboard/>
            <Box component="main" sx={{flexGrow: 1, height: '100vh', overflow: 'auto'}}>
                <Toolbar/>
                <div className={'main'}>
                    <Button variant="outlined" startIcon={<ChevronLeftIcon/>} onClick={toBack}>
                        {t('back')}
                    </Button>
                    <h2 className={'page-title text-center'}>{t('edit_document')}</h2>
                    <form className={'add-form add-document'} onSubmit={saveFormData} encType={'multipart/form-data'}>
                        <p>
                            <span>{t('document_title')}:</span>
                            <TextField
                                label={t('document_title')}
                                value={document_title}
                                onChange={(e) => setDocumentTitle(e.target.value)}
                                required type={"text"} variant="outlined"
                            />
                        </p>
                        {/* 7-o'zgarish: Kategoriya tanlash */}
                        <p>
                            <span>{t('doc_category')}:</span>
                            <Box sx={{minWidth: 200}}>
                                <FormControl fullWidth>
                                    <InputLabel id="category-select-label">{t('doc_category')}</InputLabel>
                                    <Select
                                        labelId="category-select-label"
                                        id="category-select"
                                        value={category}
                                        label={t('doc_category')}
                                        onChange={(e) => setCategory(e.target.value)}
                                    >
                                        <MenuItem value="kadastr">{t('cat_kadastr')}</MenuItem>
                                        <MenuItem value="ustav">{t('cat_ustav')}</MenuItem>
                                        <MenuItem value="guvohnoma">{t('cat_guvohnoma')}</MenuItem>
                                        <MenuItem value="xatlar">{t('cat_xatlar')}</MenuItem>
                                        <MenuItem value="other">{t('cat_other')}</MenuItem>
                                    </Select>
                                </FormControl>
                            </Box>
                        </p>
                        <p>
                            <span className={document_file === '*' ? 'text-danger' : ''}>{t('take_file')}: {document_file}</span>
                            <Button className={'file-upload-btn'} variant="contained" component="label">
                                {t('take_file')}
                                <input name={'document_file'} hidden multiple type="file"
                                       onChange={prepareUpload} title={t('take_file')}/>
                            </Button>
                        </p>
                        <Button type={'submit'} style={{width: '100%'}} variant="contained" fullWidth color={'info'}>
                            {t('save')}
                        </Button>
                    </form>
                </div>
                <Copyright/>
            </Box>
        </div>
    </div>
}

export default connect(props => props.documents, {
    getDocument,
    editSaveDocument,
    getAllVerifyResponse,
    messageReset
})(EditDocument)